/* ---------------------------------------------------------------------------
   Product personalization popup
   Custom addition — not generated by the theme build (Vite/adastra).

   - Size comes from a Shopify variant option (price follows the variant).
   - Real dimensions are read from the product "dimensions" metafield, so the
     preview is drawn to scale even when sizes are named "Petit" / "Grand".
   - Text color / font / engraved text are sent as line item properties,
     so they stay visible in the cart, in the order and in the admin.
--------------------------------------------------------------------------- */

(function () {
	"use strict";

	var SIZE_OPTION_HINTS = ["taille", "size", "dimension", "format", "diametre"];
	var COLOR_OPTION_HINTS = ["couleur", "color", "colour", "teinte", "email"];

	// Glaze swatches are photos, not hex colors, so the engraved text needs a
	// printable equivalent. Longest names are matched first ("vert clair"
	// before "vert"). Overridable per shop with the "color_map" setting.
	var COLOR_DICTIONARY = {
		"vert clair": "#8FA97A",
		"vert fonce": "#3F5D3A",
		"vert amande": "#9CB08A",
		"bleu marine": "#1F2A44",
		"bleu jean": "#4A6FA5",
		"bleu ciel": "#8FB3D9",
		"rouge vermeil": "#C1352B",
		"rouge pomme": "#B5342F",
		"beige caramel": "#B98B5E",
		"beige soutenu": "#C8A87C",
		"terracotta": "#B5654F",
		"moutarde": "#C9A227",
		"turquoise": "#3FA3A3",
		"anthracite": "#3A3A3A",
		"marron": "#6F4B32",
		"violet": "#6C4C8C",
		"orange": "#D97A34",
		"jaune": "#E4B93C",
		"beige": "#D9C3A3",
		"blanc": "#F2F0EA",
		"noir": "#1A1A1A",
		"rouge": "#A62C22",
		"rose": "#D98E9E",
		"gris": "#8A8A8A",
		"bleu": "#3B5C8F",
		"vert": "#5A7052"
	};

	var COLOR_FALLBACK = "#4A4A4A";
	var PLATE_MAX_PX_DESKTOP = 300;
	var PLATE_MAX_PX_MOBILE = 200;
	var PLATE_MIN_RATIO = 0.4;
	var FONT_MIN_PX = 10;
	var FONT_MAX_PX = 34;
	var GLYPH_WIDTH_RATIO = 0.55;

	// Metafield paragraphs that describe made-to-measure or tolerances hold
	// numbers too ("marge de 0,5cm"), and must never be read as a size.
	var DIMENSION_NOISE = ["sur-mesure", "sur mesure", "contact", "marge", "envisag", "artisanal", "⚠"];

	var SHAPES = {
		pizza:
			'<svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg" focusable="false">' +
			'<circle cx="50" cy="50" r="49" fill="#E7C489"/>' +
			'<circle cx="50" cy="50" r="41" fill="#E2A34A"/>' +
			'<circle cx="36" cy="38" r="6" fill="#B23A28"/>' +
			'<circle cx="63" cy="34" r="5" fill="#B23A28"/>' +
			'<circle cx="52" cy="58" r="6.5" fill="#B23A28"/>' +
			'<circle cx="31" cy="63" r="5" fill="#B23A28"/>' +
			'<circle cx="70" cy="62" r="5.5" fill="#B23A28"/>' +
			"</svg>",
		camembert:
			'<svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg" focusable="false">' +
			'<circle cx="50" cy="50" r="49" fill="#EDE0BE"/>' +
			'<circle cx="50" cy="50" r="41" fill="#FBF5E4"/>' +
			"</svg>",
		banana:
			'<svg viewBox="0 0 100 34" xmlns="http://www.w3.org/2000/svg" focusable="false">' +
			'<path d="M4 4c1 13 9 22 22 26 15 5 43 4 70-7-19 3-38 2-51-3C31 16 13 11 4 4Z" ' +
			'fill="#F3D04E" stroke="#DDB531" stroke-width="2" stroke-linejoin="round"/>' +
			"</svg>",
		circle:
			'<svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg" focusable="false">' +
			'<circle cx="50" cy="50" r="49" fill="#C9C2B6"/>' +
			"</svg>"
	};

	// Height relative to the declared size (a banana is long, not round).
	var SHAPE_RATIOS = { pizza: 1, camembert: 1, circle: 1, banana: 0.34 };

	function parseJSON(element) {
		if (!element) {
			return null;
		}

		try {
			return JSON.parse(element.textContent);
		} catch (error) {
			return null;
		}
	}

	function normalize(value) {
		return String(value || "")
			.toLowerCase()
			.normalize("NFD")
			.replace(/[\u0300-\u036f]/g, "")
			.trim();
	}

	/**
	 * Largest number of centimeters in a label ("Petit : 29cm ø",
	 * "ø 20 cm / 3 cm de prof."). Returns null when there is none.
	 */
	function extractCm(label) {
		var text = String(label || "");

		if (normalize(text).indexOf("cm") === -1) {
			return null;
		}

		var matches = text.match(/\d+(?:[.,]\d+)?/g);

		if (!matches) {
			return null;
		}

		var value = matches.reduce(function (max, current) {
			var number = parseFloat(current.replace(",", "."));
			return number > max ? number : max;
		}, 0);

		return value > 0 ? value : null;
	}

	/**
	 * Parses the "Nom: #hex" lines of the color_map setting.
	 */
	function parseColorMap(raw) {
		var map = {};

		String(raw || "")
			.split(/[\n,;]+/)
			.forEach(function (line) {
				var parts = line.split(":");

				if (parts.length < 2) {
					return;
				}

				var name = normalize(parts[0]);
				var value = parts.slice(1).join(":").trim();

				if (name && value) {
					map[name] = value;
				}
			});

		return map;
	}

	/**
	 * Printable color for an option value: the native Shopify swatch first,
	 * then the shop's own mapping, then the built-in dictionary.
	 */
	function resolveColor(name, swatch, map) {
		if (swatch && /^#|^rgb|^hsl/i.test(String(swatch).trim())) {
			return String(swatch).trim();
		}

		var normalized = normalize(name);

		if (map[normalized]) {
			return map[normalized];
		}

		var keys = Object.keys(COLOR_DICTIONARY).sort(function (a, b) {
			return b.length - a.length;
		});

		for (var i = 0; i < keys.length; i++) {
			if (normalized.indexOf(keys[i]) !== -1) {
				return COLOR_DICTIONARY[keys[i]];
			}
		}

		return COLOR_FALLBACK;
	}

	function formatMoney(cents) {
		var utils = window.themeCore && window.themeCore.utils;
		var format =
			window.themeCore &&
			window.themeCore.objects &&
			window.themeCore.objects.shop &&
			window.themeCore.objects.shop.money_format;

		if (!utils || !utils.formatMoney || !format) {
			return "";
		}

		return utils.formatMoney(cents, format);
	}

	function formatCm(value) {
		if (!value) {
			return "";
		}

		return String(value).replace(".", ",") + " cm";
	}

	function PersonalizationPopup(popup) {
		var section = popup.closest("[data-section-id]");
		var productForm = section && section.querySelector("[data-js-product-form]");

		var variants = parseJSON(popup.querySelector("[data-personalization-variants]")) || [];
		var colors = parseJSON(popup.querySelector("[data-personalization-colors]")) || [];
		var productOptions = parseJSON(popup.querySelector("[data-personalization-options]")) || [];
		var optionValues = parseJSON(popup.querySelector("[data-personalization-option-values]")) || [];
		var references = parseJSON(popup.querySelector("[data-personalization-references]")) || [];

		var sizesContainer = popup.querySelector(".js-personalization-sizes");
		var sizesFieldset = popup.querySelector(".js-personalization-sizes-container");
		var colorsContainer = popup.querySelector(".js-personalization-colors");
		var colorsFieldset = popup.querySelector(".js-personalization-colors-container");
		var referencesFieldset = popup.querySelector(".js-references-container");
		var referencesList = popup.querySelector(".js-references-list");
		var referencesLayer = popup.querySelector(".js-preview-references");
		var fontInputs = [].slice.call(popup.querySelectorAll(".js-personalization-font-input"));
		var textInput = popup.querySelector(".js-personalization-text");
		var counter = popup.querySelector(".js-personalization-counter");
		var errorElement = popup.querySelector(".js-personalization-error");
		var submitButton = popup.querySelector(".js-personalization-submit");
		var priceElement = popup.querySelector(".js-personalization-price");
		var plate = popup.querySelector(".js-preview-plate");
		var previewText = popup.querySelector(".js-preview-text");
		var previewCaption = popup.querySelector(".js-preview-caption");

		var maxCharacters = parseInt(popup.dataset.maxCharacters, 10) || 25;
		var propertyNames = {
			text: popup.dataset.propertyText || "Texte personnalisé",
			color: popup.dataset.propertyColor || "Couleur du texte",
			font: popup.dataset.propertyFont || "Police"
		};

		var sizeOptionIndex = -1;
		var colorOptionIndex = -1;
		var colorMap = parseColorMap(popup.dataset.colorMap);
		var sizeValues = [];
		var dimensions = { map: {}, fallback: null };
		var selectedOptions = [];
		var toggle = null;
		var isLoading = false;

		function init() {
			if (!sizesContainer || !colorsContainer || !textInput || !submitButton || !plate) {
				return;
			}

			sizeOptionIndex = findOptionIndex(popup.dataset.sizeOptionName, SIZE_OPTION_HINTS, []);
			colorOptionIndex = findColorOptionIndex();
			selectedOptions = getCurrentOptions();

			collectSizeValues();
			dimensions = parseDimensions();

			buildSizes();
			buildColors();
			buildReferences();
			bindEvents();
			initToggle();
			render();
		}

		/**
		 * Finds a product option by the name set in the theme editor, then by
		 * common naming conventions. `taken` excludes indexes already claimed by
		 * another field.
		 */
		function findOptionIndex(configuredName, hints, taken) {
			if (!productOptions.length) {
				return -1;
			}

			var configured = normalize(configuredName);
			var i;

			if (configured) {
				for (i = 0; i < productOptions.length; i++) {
					if (taken.indexOf(i) === -1 && normalize(productOptions[i]).indexOf(configured) !== -1) {
						return i;
					}
				}
			}

			for (i = 0; i < productOptions.length; i++) {
				if (taken.indexOf(i) !== -1) {
					continue;
				}

				var name = normalize(productOptions[i]);

				for (var k = 0; k < hints.length; k++) {
					if (name.indexOf(hints[k]) !== -1) {
						return i;
					}
				}
			}

			return -1;
		}

		/**
		 * The text color can come from a product option (each variant is a glaze
		 * color) or from the list defined in the theme editor.
		 */
		function findColorOptionIndex() {
			var source = popup.dataset.colorSource || "auto";

			if (source === "list") {
				return -1;
			}

			var index = findOptionIndex(popup.dataset.colorOptionName, COLOR_OPTION_HINTS, [sizeOptionIndex]);

			if (source === "variant" && index < 0 && productOptions.length) {
				// Explicitly asked for variants but no name matched: use the first
				// option that is not the size one.
				for (var i = 0; i < productOptions.length; i++) {
					if (i !== sizeOptionIndex) {
						return i;
					}
				}
			}

			return index;
		}

		function getOptionValues(index) {
			var option = optionValues[index];

			return option && option.values ? option.values : [];
		}

		function collectSizeValues() {
			if (sizeOptionIndex < 0) {
				return;
			}

			var seen = {};

			variants.forEach(function (variant) {
				var value = variant.options[sizeOptionIndex];

				if (value === undefined || seen[value]) {
					return;
				}

				seen[value] = true;
				sizeValues.push(value);
			});
		}

		/**
		 * Reads the "dimensions" metafield, flattened to "segment|segment" by the
		 * Liquid snippet, and maps each size name to its real diameter:
		 *   "Petit : 29cm ø|Grand : 33cm ø|…"  -> { Petit: 29, Grand: 33 }
		 *   "ø 20 cm / 3 cm de prof.|…"        -> fallback 20
		 */
		function parseDimensions() {
			var raw = popup.dataset.dimensions || "";
			var result = { map: {}, fallback: null };

			raw.split("|").forEach(function (segment) {
				var text = segment.trim();

				if (!text) {
					return;
				}

				var normalized = normalize(text);
				var isNoise = DIMENSION_NOISE.some(function (word) {
					return normalized.indexOf(normalize(word)) !== -1;
				});

				if (isNoise) {
					return;
				}

				var cm = extractCm(text);

				if (cm === null) {
					return;
				}

				var label = normalize(text.split(":")[0]);
				var matched = false;

				sizeValues.forEach(function (value) {
					if (label && label.indexOf(normalize(value)) !== -1) {
						result.map[value] = cm;
						matched = true;
					}
				});

				if (!matched && result.fallback === null) {
					result.fallback = cm;
				}
			});

			return result;
		}

		/**
		 * Real size of one option value: metafield first, then the label itself
		 * ("30 cm"), then the product-wide dimension.
		 */
		function getSizeCm(value) {
			if (dimensions.map[value] !== undefined) {
				return dimensions.map[value];
			}

			var fromLabel = extractCm(value);

			if (fromLabel !== null) {
				return fromLabel;
			}

			if (sizeValues.length <= 1) {
				return dimensions.fallback;
			}

			return null;
		}

		/**
		 * Reads the options of the variant currently selected on the page, so the
		 * popup opens on what the customer already picked.
		 */
		function getCurrentOptions() {
			var idInput = productForm && productForm.querySelector('[name="id"]');
			var currentId = idInput && idInput.value;
			var current = null;

			if (currentId) {
				current = variants.filter(function (variant) {
					return String(variant.id) === String(currentId);
				})[0];
			}

			if (!current) {
				current =
					variants.filter(function (variant) {
						return variant.available;
					})[0] || variants[0];
			}

			return current ? current.options.slice() : [];
		}

		function buildSizes() {
			if (sizeOptionIndex < 0 || sizeValues.length < 2) {
				if (sizesFieldset) {
					sizesFieldset.hidden = true;
				}
				return;
			}

			var name = "personalization-size-" + popup.id;

			sizeValues.forEach(function (value) {
				var variant = findVariantForSize(value);
				var label = document.createElement("label");
				label.className = "personalization-size";

				var input = document.createElement("input");
				input.type = "radio";
				input.name = name;
				input.value = value;
				input.className = "visually-hidden js-personalization-size-input";
				input.checked = selectedOptions[sizeOptionIndex] === value;
				input.disabled = !variant || !variant.available;

				var box = document.createElement("span");
				box.className = "personalization-size__box";

				var title = document.createElement("span");
				title.className = "personalization-size__name";
				title.textContent = value;
				box.appendChild(title);

				var cm = getSizeCm(value);

				if (cm) {
					var dimension = document.createElement("span");
					dimension.className = "personalization-size__dimension";
					dimension.textContent = formatCm(cm);
					box.appendChild(dimension);
				}

				if (variant && variant.available && hasVaryingPrices()) {
					var price = document.createElement("span");
					price.className = "personalization-size__price";
					price.textContent = formatMoney(variant.price);
					box.appendChild(price);
				}

				label.appendChild(input);
				label.appendChild(box);
				sizesContainer.appendChild(label);
			});

			var checked = sizesContainer.querySelector("input:checked:not(:disabled)");

			if (!checked) {
				var fallback = sizesContainer.querySelector("input:not(:disabled)");

				if (fallback) {
					fallback.checked = true;
					selectedOptions[sizeOptionIndex] = fallback.value;
				}
			}
		}

		function hasVaryingPrices() {
			if (!variants.length) {
				return false;
			}

			var first = variants[0].price;

			return variants.some(function (variant) {
				return variant.price !== first;
			});
		}

		/**
		 * Text colors come from the "Couleur" product option when the product has
		 * one — each glaze is a real variant — otherwise from the theme editor
		 * list, sent as a line item property.
		 */
		function buildColors() {
			var entries = usesVariantColors()
				? getOptionValues(colorOptionIndex).map(function (value) {
						return {
							name: value.value,
							value: resolveColor(value.value, value.swatch, colorMap)
						};
				  })
				: colors;

			if (!entries.length) {
				if (colorsFieldset) {
					colorsFieldset.hidden = true;
				}
				return;
			}

			var name = "personalization-color-" + popup.id;
			var current = usesVariantColors() ? selectedOptions[colorOptionIndex] : null;

			entries.forEach(function (color, index) {
				var label = document.createElement("label");
				label.className = "personalization-color";
				label.title = color.name;

				var input = document.createElement("input");
				input.type = "radio";
				input.name = name;
				input.value = color.name;
				input.className = "visually-hidden js-personalization-color-input";
				input.checked = current ? current === color.name : index === 0;
				input.dataset.colorValue = color.value;

				var box = document.createElement("span");
				box.className = "personalization-color__box";
				box.style.backgroundColor = color.value;

				var text = document.createElement("span");
				text.className = "visually-hidden";
				text.textContent = color.name;

				label.appendChild(input);
				label.appendChild(box);
				label.appendChild(text);
				colorsContainer.appendChild(label);
			});

			if (usesVariantColors()) {
				refreshColorAvailability();
			}
		}

		function usesVariantColors() {
			return colorOptionIndex >= 0;
		}

		function getColorInputs() {
			return [].slice.call(colorsContainer.querySelectorAll(".js-personalization-color-input"));
		}

		/**
		 * Greys out the glazes that do not exist (or are sold out) for the size
		 * currently selected, and moves the selection if it became unavailable.
		 */
		function refreshColorAvailability() {
			if (!usesVariantColors()) {
				return;
			}

			var inputs = getColorInputs();

			inputs.forEach(function (input) {
				var available = variants.some(function (variant) {
					if (variant.options[colorOptionIndex] !== input.value) {
						return false;
					}

					if (sizeOptionIndex >= 0 && variant.options[sizeOptionIndex] !== selectedOptions[sizeOptionIndex]) {
						return false;
					}

					return variant.available;
				});

				input.disabled = !available;
				input.closest(".personalization-color").classList.toggle("is-unavailable", !available);
			});

			var checked = inputs.filter(function (input) {
				return input.checked && !input.disabled;
			})[0];

			if (checked) {
				return;
			}

			var replacement = inputs.filter(function (input) {
				return !input.disabled;
			})[0];

			if (replacement) {
				replacement.checked = true;
				selectedOptions[colorOptionIndex] = replacement.value;
			}
		}

		/**
		 * Everyday objects the customer can toggle on to judge the real size.
		 * Only meaningful once we know how many centimeters a plate measures.
		 */
		function buildReferences() {
			if (!referencesFieldset || !referencesList || !references.length || !hasKnownDimensions()) {
				return;
			}

			referencesFieldset.hidden = false;

			references.forEach(function (reference) {
				var label = document.createElement("label");
				label.className = "personalization-reference";

				var input = document.createElement("input");
				input.type = "checkbox";
				input.className = "visually-hidden js-personalization-reference-input";
				input.value = String(reference.id);
				input.dataset.size = String(reference.size);
				input.dataset.shape = reference.shape;

				var box = document.createElement("span");
				box.className = "personalization-reference__box";

				var icon = document.createElement("span");
				icon.className = "personalization-reference__icon";
				icon.innerHTML = SHAPES[reference.shape] || SHAPES.circle;

				var text = document.createElement("span");
				text.textContent = reference.label + " · " + formatCm(reference.size);

				box.appendChild(icon);
				box.appendChild(text);
				label.appendChild(input);
				label.appendChild(box);
				referencesList.appendChild(label);
			});
		}

		function hasKnownDimensions() {
			if (dimensions.fallback !== null) {
				return true;
			}

			return sizeValues.some(function (value) {
				return getSizeCm(value) !== null;
			});
		}

		function getActiveReferences() {
			if (!referencesList) {
				return [];
			}

			return [].slice
				.call(referencesList.querySelectorAll(".js-personalization-reference-input:checked"))
				.map(function (input) {
					return {
						size: parseFloat(input.dataset.size) || 0,
						shape: input.dataset.shape
					};
				})
				.filter(function (reference) {
					return reference.size > 0;
				});
		}

		function bindEvents() {
			sizesContainer.addEventListener("change", function (event) {
				if (!event.target.classList.contains("js-personalization-size-input")) {
					return;
				}

				selectedOptions[sizeOptionIndex] = event.target.value;
				refreshColorAvailability();
				syncPageVariant();
				render();
			});

			colorsContainer.addEventListener("change", function (event) {
				if (!event.target.classList.contains("js-personalization-color-input")) {
					return;
				}

				if (usesVariantColors()) {
					selectedOptions[colorOptionIndex] = event.target.value;
					syncPageVariant();
				}

				render();
			});

			if (referencesList) {
				referencesList.addEventListener("change", render);
			}

			fontInputs.forEach(function (input) {
				input.addEventListener("change", render);
			});

			textInput.addEventListener("input", function () {
				hideError();
				render();
			});

			submitButton.addEventListener("click", addToCart);

			window.addEventListener("resize", render);
		}

		function initToggle() {
			var Toggle = window.themeCore.utils && window.themeCore.utils.Toggle;

			if (!Toggle) {
				return;
			}

			toggle = Toggle({ toggleSelector: popup.id });
			toggle.init();

			popup.addEventListener("click", function (event) {
				if (event.target === popup && toggle) {
					toggle.close(popup);
				}
			});

			window.themeCore.EventBus.listen("Toggle:" + popup.id + ":open", onOpen);
		}

		/**
		 * Re-syncs the popup with the variant selected on the page each time it
		 * opens, then focuses the text field.
		 */
		function onOpen() {
			var pageOptions = getCurrentOptions();

			if (sizeOptionIndex >= 0 && pageOptions.length) {
				var value = pageOptions[sizeOptionIndex];
				var input = [].slice
					.call(sizesContainer.querySelectorAll(".js-personalization-size-input"))
					.filter(function (element) {
						return element.value === value && !element.disabled;
					})[0];

				if (input) {
					input.checked = true;
					selectedOptions[sizeOptionIndex] = value;
				}
			}

			if (usesVariantColors() && pageOptions.length) {
				var colorValue = pageOptions[colorOptionIndex];
				var colorInput = getColorInputs().filter(function (element) {
					return element.value === colorValue;
				})[0];

				if (colorInput) {
					colorInput.checked = true;
					selectedOptions[colorOptionIndex] = colorValue;
				}

				refreshColorAvailability();
			}

			render();

			// On mobile the preview is pinned at the top and an auto-focus would
			// pop the keyboard over it straight away.
			if (window.innerWidth >= 768) {
				window.setTimeout(function () {
					textInput.focus();
				}, 100);
			}
		}

		/**
		 * A size is buyable as long as one of its variants is available, whatever
		 * the other options are.
		 */
		function findVariantForSize(value) {
			var matching = variants.filter(function (variant) {
				return variant.options[sizeOptionIndex] === value;
			});

			return (
				matching.filter(function (variant) {
					return variant.available;
				})[0] || matching[0]
			);
		}

		function firstAvailable(list) {
			return list.filter(function (variant) {
				return variant.available;
			})[0];
		}

		function getSelectedVariant() {
			if (!variants.length) {
				return null;
			}

			if (sizeOptionIndex < 0 && colorOptionIndex < 0) {
				return firstAvailable(variants) || variants[0];
			}

			var exact = variants.filter(function (variant) {
				return variant.options.every(function (option, index) {
					return option === selectedOptions[index];
				});
			})[0];

			if (exact && exact.available) {
				return exact;
			}

			// Keep what the customer actually chose (size and glaze) and let the
			// options the popup does not drive float.
			var matching = variants.filter(function (variant) {
				if (sizeOptionIndex >= 0 && variant.options[sizeOptionIndex] !== selectedOptions[sizeOptionIndex]) {
					return false;
				}

				if (colorOptionIndex >= 0 && variant.options[colorOptionIndex] !== selectedOptions[colorOptionIndex]) {
					return false;
				}

				return true;
			});

			var available = firstAvailable(matching);

			if (available) {
				return available;
			}

			if (exact) {
				return exact;
			}

			if (matching.length) {
				return matching[0];
			}

			var sameSize = variants.filter(function (variant) {
				return sizeOptionIndex < 0 || variant.options[sizeOptionIndex] === selectedOptions[sizeOptionIndex];
			});

			return firstAvailable(sameSize) || sameSize[0] || variants[0];
		}

		/**
		 * Mirrors the size chosen in the popup back onto the product form, so the
		 * page price and the popup stay consistent.
		 */
		function syncPageVariant() {
			var variant = getSelectedVariant();
			var idInput = productForm && productForm.querySelector('[name="id"]');

			if (!variant) {
				return;
			}

			selectedOptions = variant.options.slice();
			updatePagePrice(variant);

			if (!idInput || idInput.value === String(variant.id)) {
				return;
			}

			idInput.value = variant.id;
			idInput.dispatchEvent(new Event("change", { bubbles: true }));
		}

		/**
		 * The page shows "à partir de …" until a choice is made; from then on it
		 * mirrors the exact price of the selected variant. Only called on a real
		 * customer action, never on load.
		 */
		function updatePagePrice(variant) {
			if (!section || !variant) {
				return;
			}

			var container = section.querySelector(".js-price");

			if (!container || popup.contains(container)) {
				return;
			}

			[].slice.call(container.querySelectorAll("[data-product-price]")).forEach(function (element) {
				element.textContent = formatMoney(variant.price);
				element.setAttribute("data-amount", variant.price);
			});

			var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;

			container.classList.toggle("price--on-sale", !!onSale);

			[].slice.call(container.querySelectorAll("[data-price-old]")).forEach(function (element) {
				element.textContent = onSale ? formatMoney(variant.compare_at_price) : "";
			});
		}

		function getSelectedColor() {
			var checked = colorsContainer.querySelector(".js-personalization-color-input:checked");

			if (checked) {
				return { name: checked.value, value: checked.dataset.colorValue };
			}

			if (usesVariantColors()) {
				var value = selectedOptions[colorOptionIndex];

				if (value === undefined) {
					return null;
				}

				return { name: value, value: resolveColor(value, "", colorMap) };
			}

			return colors[0] || null;
		}

		function getSelectedFont() {
			var checked = fontInputs.filter(function (input) {
				return input.checked;
			})[0];

			if (!checked) {
				return { name: "Times New Roman", stack: "'Times New Roman', Times, serif" };
			}

			return { name: checked.value, stack: checked.dataset.fontStack };
		}

		function getSelectedCm() {
			if (sizeOptionIndex < 0) {
				return dimensions.fallback;
			}

			return getSizeCm(selectedOptions[sizeOptionIndex]);
		}

		function getMaxPx() {
			if (window.innerWidth >= 768) {
				return PLATE_MAX_PX_DESKTOP;
			}

			// On mobile the preview stays pinned above the fields, so it must not
			// take more than roughly a third of the screen.
			return Math.min(PLATE_MAX_PX_MOBILE, Math.round(window.innerHeight * 0.28));
		}

		/**
		 * Pixels per centimeter, shared by the plate and the reference objects so
		 * every shape on the stage is drawn at the same scale. The largest object
		 * on screen — plate or reference — fills the stage.
		 */
		function getPixelsPerCm() {
			var sizes = sizeValues
				.map(getSizeCm)
				.filter(function (value) {
					return value;
				})
				.concat(
					getActiveReferences().map(function (reference) {
						return reference.size;
					})
				);

			if (dimensions.fallback) {
				sizes.push(dimensions.fallback);
			}

			if (!sizes.length) {
				return null;
			}

			var max = Math.max.apply(null, sizes);

			return max > 0 ? getMaxPx() / max : null;
		}

		/**
		 * Plate diameter, to scale when the real dimensions are known; otherwise
		 * sizes are simply spread evenly from smallest to largest.
		 */
		function getPlateSize() {
			var maxPx = getMaxPx();
			var pixelsPerCm = getPixelsPerCm();
			var cm = getSelectedCm();

			if (pixelsPerCm && cm) {
				return cm * pixelsPerCm;
			}

			if (sizeOptionIndex < 0 || sizeValues.length < 2) {
				return maxPx * 0.75;
			}

			var index = sizeValues.indexOf(selectedOptions[sizeOptionIndex]);

			if (index < 0) {
				index = 0;
			}

			var ratio = PLATE_MIN_RATIO + (index / (sizeValues.length - 1)) * (1 - PLATE_MIN_RATIO);

			return maxPx * ratio;
		}

		function render() {
			var plateSize = getPlateSize();
			var font = getSelectedFont();
			var color = getSelectedColor();
			var value = textInput.value;

			plate.style.width = Math.round(plateSize) + "px";
			plate.style.height = Math.round(plateSize) + "px";

			previewText.textContent = value;
			previewText.style.fontFamily = font.stack;
			previewText.style.color = color ? color.value : "";
			previewText.style.fontSize = getPreviewFontSize(plateSize, value.length) + "px";

			if (counter) {
				counter.textContent = value.length + "/" + maxCharacters;
				counter.classList.toggle("is-limit", value.length >= maxCharacters);
			}

			renderReferences();
			renderCaption();
			renderPrice();

			submitButton.disabled = !value.trim() || !getSelectedVariant();
		}

		function renderReferences() {
			if (!referencesLayer) {
				return;
			}

			var pixelsPerCm = getPixelsPerCm();
			var active = getActiveReferences();

			referencesLayer.innerHTML = "";

			if (!pixelsPerCm || !active.length) {
				return;
			}

			active.forEach(function (reference) {
				var width = reference.size * pixelsPerCm;
				var ratio = SHAPE_RATIOS[reference.shape] || 1;
				var element = document.createElement("div");

				element.className = "personalization-preview__reference";
				element.style.width = Math.round(width) + "px";
				element.style.height = Math.round(width * ratio) + "px";
				element.innerHTML = SHAPES[reference.shape] || SHAPES.circle;

				referencesLayer.appendChild(element);
			});
		}

		function getPreviewFontSize(plateSize, length) {
			if (!length) {
				return FONT_MAX_PX;
			}

			// The plate keeps a 12% inner padding on each side.
			var available = plateSize * 0.76;
			var size = available / (length * GLYPH_WIDTH_RATIO);

			return Math.round(Math.min(FONT_MAX_PX, Math.max(FONT_MIN_PX, size)));
		}

		function renderCaption() {
			if (!previewCaption) {
				return;
			}

			var parts = [];
			var cm = getSelectedCm();

			if (sizeOptionIndex >= 0 && selectedOptions[sizeOptionIndex]) {
				parts.push(selectedOptions[sizeOptionIndex]);
			}

			if (cm) {
				parts.push(formatCm(cm));
			}

			var color = getSelectedColor();

			if (color) {
				parts.push(color.name);
			}

			parts.push(getSelectedFont().name);

			previewCaption.textContent = parts.join(" · ");
		}

		function renderPrice() {
			if (!priceElement) {
				return;
			}

			var variant = getSelectedVariant();

			priceElement.textContent = variant ? formatMoney(variant.price) : "";
		}

		function showError(message) {
			if (!errorElement) {
				return;
			}

			errorElement.textContent = message;
			errorElement.classList.add("is-visible");
		}

		function hideError() {
			if (!errorElement) {
				return;
			}

			errorElement.textContent = "";
			errorElement.classList.remove("is-visible");
		}

		function getQuantity() {
			var input = productForm && productForm.querySelector('[name="quantity"]');
			var quantity = input ? parseInt(input.value, 10) : 1;

			return quantity > 0 ? quantity : 1;
		}

		function addToCart() {
			if (isLoading) {
				return;
			}

			var value = textInput.value.trim();
			var variant = getSelectedVariant();

			if (!value) {
				showError(textInput.dataset.errorRequired || "Merci de saisir le texte à personnaliser.");
				textInput.focus();
				return;
			}

			if (!variant || !variant.available) {
				showError(textInput.dataset.errorUnavailable || "Cette taille n'est plus disponible.");
				return;
			}

			hideError();
			setLoading(true);

			var properties = {};
			properties[propertyNames.text] = value;

			var color = getSelectedColor();

			// When the glaze is a variant, its name is already on the line item
			// through the variant title — no need to repeat it as a property.
			if (color && !usesVariantColors()) {
				properties[propertyNames.color] = color.name;
			}

			properties[propertyNames.font] = getSelectedFont().name;

			var CartApi = window.themeCore.CartApi;

			CartApi.makeRequest(CartApi.actions.ADD_TO_CART, {
				id: variant.id,
				quantity: getQuantity(),
				properties: properties
			})
				.then(function () {
					return CartApi.makeRequest(CartApi.actions.GET_CART);
				})
				.then(function () {
					setLoading(false);

					if (toggle) {
						toggle.close(popup);
					}

					textInput.value = "";
					render();
				})
				.catch(function (error) {
					setLoading(false);

					var CartNotificationError = window.themeCore.CartNotificationError;

					if (CartNotificationError) {
						CartNotificationError.addNotification(error && error.description);
						CartNotificationError.open();
					} else {
						showError((error && error.description) || "Une erreur est survenue.");
					}
				});
		}

		function setLoading(state) {
			isLoading = state;
			submitButton.classList.toggle("is-loading", state);
			submitButton.disabled = state;
		}

		return { init: init };
	}

	function initAll() {
		var popups = [].slice.call(document.querySelectorAll(".js-personalization-popup"));

		popups.forEach(function (popup) {
			if (popup.dataset.personalizationInitialized) {
				return;
			}

			popup.dataset.personalizationInitialized = "true";
			PersonalizationPopup(popup).init();
		});
	}

	function whenThemeReady(callback) {
		var attempts = 0;

		(function check() {
			var ready =
				window.themeCore &&
				window.themeCore.utils &&
				window.themeCore.utils.Toggle &&
				window.themeCore.CartApi &&
				window.themeCore.EventBus;

			if (ready) {
				callback();
				return;
			}

			if (attempts++ > 200) {
				return;
			}

			window.setTimeout(check, 50);
		})();
	}

	whenThemeReady(initAll);

	// Shopify theme editor: re-init when the section is re-rendered.
	document.addEventListener("shopify:section:load", function () {
		whenThemeReady(initAll);
	});
})();
